import { saveAs } from "file-saver";

// Download Files Cloud Base URL 
export const cloudBaseURL = 'https://climax.azurewebsites.net/assets/uploads/'

export function getToken() {
    let userAuth: any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
    return userAuth?.accessToken;
}

export function getRefreshToken() {
    let userAuth: any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
    return userAuth?.refreshToken
};


export function getTokenFormat() {
    const token = getToken();
    if (token) {
        return { headers: { Authorization: `Bearer ${token}` } };
    }
}

export function updateLocalAccessToken(token: any) {
    let userAuth: any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
    userAuth.accessToken = token;
    localStorage.setItem("user", JSON.stringify(userAuth));
}

export function CurrentUserInfo() {
    let userAuth: any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null
    return userAuth
}

export const downloadFile = (url: string, name: string) => {
    saveAs(url, name)
}


export const downloadS3File = async (url: string): Promise<void> => {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        const filename = decodeURIComponent(url.split("/").pop() || "download");

        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke blob URL after download
        window.URL.revokeObjectURL(blobUrl);

        console.log(`✅ Download started for: ${filename}`);
    } catch (error: any) {
        console.error(`❌ Failed to download: ${error.message}`);
    }
};
